import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import BuyBoxPhoto from './buy-box-photo';
import BuyBoxSale from './buy-box-sale';
import { useVariantContextValues } from '../../context/use-variant-context-values';
import NotSalable from '../not-salable';
import PDPBuyingPolicies from '../pdp-buying-policies';
interface Props {
  className?: string;
  hasPhoto: boolean;
}
const BuyBox = ({
  hasPhoto
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  const {
    activePricing
  } = useVariantContextValues('pdp');
  const {
    isSalable
  } = activePricing;
  if (isMobile) return null;
  return <div className='hidden min-h-[352px] w-[316px] flex-col justify-between gap-6 rounded border border-border-gray-light bg-surface-solid-50 px-3 py-5 shadow-sm lg:flex' data-sentry-component="BuyBox" data-sentry-source-file="index.tsx">
            {hasPhoto ? <BuyBoxPhoto /> : <PDPBuyingPolicies type='desktop' />}

            {isSalable ? <BuyBoxSale hasPhoto={hasPhoto} /> : <NotSalable type='buy-box' />}
        </div>;
};
export default BuyBox;